import React, { useState, useContext, useEffect } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import './MarketIPO.css';
import { useNavigate } from "react-router-dom";

function MarketMF(props) {
    const [optionType, setOptionType] = useState('');
    let getOptionValue = props.optionValue;
    let navigate = useNavigate();

    useEffect(() => {
        if (optionType === "Overview") {
            navigate("/market/ipo");
        }
        if (optionType === "Forthcoming IPO") {
            navigate("/IPO/Forthcoming-IPO");
        }
        if (optionType === "Open IPO") {
            navigate("/IPO/Open-IPO");
        }
        if (optionType === "Closed IPO") {
            navigate("/IPO/Closed-IPO");
        }
        if (optionType === "New Listing") {
            navigate("/IPO/New-Listing");
        }
        if (optionType === "Basis Of Allotment") {
            navigate("/IPO/Basis-Of-Allotment");
        }
        if (optionType === "Draft Prospectus") {
            navigate("/IPO/Draft-Prospectus");
        }
        if (optionType === "Best Performers") {
            navigate("/IPO/Best-Performers");
        }
        if (optionType === "IPO News") {
            navigate("/IPO/IPO-News");
        }
    }, [optionType]);


    return (
        <>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='market-loser-sc'>
                            <div className='market-inner'>
                                <div className='market-select'>
                                    <select value={getOptionValue} onChange={(event) => { setOptionType(event.target.value) }}>
                                        <option value="Overview">Overview</option>
                                        <option value="Forthcoming IPO">Forthcoming IPO</option>
                                        <option value="Open IPO">Open IPO</option>
                                        <option value="Closed IPO">Closed IPO</option>
                                        <option value="New Listing">New Listing</option>
                                        <option value="Basis Of Allotment">Basis Of Allotment</option>
                                        <option value="Draft Prospectus">Draft Prospectus</option>
                                        <option value="Best Performers">Best Performers</option>
                                        <option value="IPO News">IPO News</option>
                                    </select>
                                </div>
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default MarketMF;